<template>
    <div class='t_content_view'>
        <!-- 页面标题 -->
        <div class="t_page_title">聊天记录<small>查询与回溯全量会话存档（客服工作台 / AI 接待）</small></div>

        <!-- 检索条件 -->
        <div class="t_panel">
            <div class="t_panel_head">
                <div class="t_panel_title">🔍 检索条件</div>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="t_fld">
                        <label>会话 ID</label>
                        <el-input size="default" v-model.trim="searchdata.sid" placeholder="如 S-20418…" clearable @keyup.enter="searchbtn" />
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>企微主体</label>
                        <el-select style="width: 100%;" multiple clearable v-model="searchdata.corp_ids" placeholder="全部">
                            <el-option v-for="(item, index) in corpList.data" :key="index" :label="item.corp_name" :value="item.id" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>接待人</label>
                        <el-select style="width: 100%;" multiple clearable v-model="searchdata.employee_ids" placeholder="全部">
                            <el-option v-for="(item, index) in allpeolist2.data" :key="index" :label="item.username" :value="item.id" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>客户昵称</label>
                        <el-input v-model.trim="searchdata.name" placeholder="请输入客户昵称" clearable @keyup.enter="searchbtn" />
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>客户手机号</label>
                        <el-input v-model.trim="searchdata.phone" placeholder="请输入客户手机号" clearable @input="handleEdit" @keyup.enter="searchbtn" />
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>聊天日期</label>
                        <el-date-picker
                            v-model="timeaer"
                            @change="changedate"
                            type="daterange"
                            size="default"
                            value-format="YYYY-MM-DD"
                            clearable
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            style="width: 100%;"
                        />
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>接待坐席</label>
                        <el-select style="width: 100%;" multiple clearable v-model="searchdata.internal_user_ids" placeholder="全部">
                            <el-option v-for="(item, index) in allpeolist.data" :key="index" :label="item.name" :value="item.id" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>发起场景</label>
                        <el-select style="width: 100%;" clearable v-model="searchdata.scene" placeholder="全部">
                            <el-option v-for="item in sceneoptions.data" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="t_fld">
                        <label>接待方式</label>
                        <el-select style="width: 100%;" clearable v-model="searchdata.channel" placeholder="全部">
                            <el-option v-for="item in channeloptions.data" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8" v-if="false">
                    <div class="t_fld">
                        <label>聊天内容</label>
                        <el-input v-model.trim="searchdata.keywords" placeholder="搜索对话关键词…" clearable @keyup.enter="searchbtn" />
                    </div>
                </el-col>
            </el-row>
            <div class="t_filter_actions">
                <el-button class="t_btn_primary" @click="searchbtn()">查询</el-button>
                <el-button class="t_btn_ghost" @click="resetsearch()">重置</el-button>
            </div>
        </div>

        <!-- 统计卡片 -->
        <div class="t_stat_row">
            <div class="t_stat_card">
                <div class="t_stat_label"><span class="t_dot" style="background: #4F46E5"></span>匹配会话数</div>
                <div class="t_stat_value">{{ kpi.total ?? '—' }}</div>
                <div class="t_stat_sub">当前检索条件下</div>
            </div>
            <div class="t_stat_card">
                <div class="t_stat_label"><span class="t_dot" style="background: #10B981"></span>AI 承接</div>
                <div class="t_stat_value">{{ kpi.ai ?? '—' }}</div>
                <div class="t_stat_sub">占比 <b>{{ kpi.aiPct === null ? '—' : kpi.aiPct + '%' }}</b></div>
            </div>
            <div class="t_stat_card">
                <div class="t_stat_label"><span class="t_dot" style="background: #F59E0B"></span>人工接待</div>
                <div class="t_stat_value">{{ kpi.human ?? '—' }}</div>
                <div class="t_stat_sub">占比 <b>{{ kpi.humanPct === null ? '—' : kpi.humanPct + '%' }}</b></div>
            </div>
            <div class="t_stat_card">
                <div class="t_stat_label"><span class="t_dot" style="background: #9333EA"></span>AI 转人工</div>
                <div class="t_stat_value">{{ kpi.ait ?? '—' }}</div>
                <div class="t_stat_sub">AI 主动转交真人</div>
            </div>
        </div>

        <!-- 会话列表 -->
        <div class="t_table_panel">
            <el-table
                :data="tableData.data"
                style="width: 100%"
                :header-cell-style="{
                    background: '#FBFCFE',
                    color: '#64748B',
                    fontWeight: '700',
                    fontSize: '12.5px',
                    borderBottom: '1px solid #E8ECF3'
                }"
            >
                <el-table-column label="会话 ID">
                    <template #default="{ row }"><span class="t_id_cell">{{ row.reception_display_id }}</span></template>
                </el-table-column>
                <el-table-column label="客户">
                    <template #default="{ row }">
                        <div class="t_cust_cell">
                            <span class="t_cust_name">{{ row.contact_name || row.external_contact_name || '-' }}</span>
                            <span class="t_cust_id">{{ row.external_contact_id || '-' }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="企微主体">
                    <template #default="{ row }">
                        <div class="t_corp_cell"><span class="t_corp_dot" :style="{ background: row.corpColor }"></span><span class="t_corp_name">{{ row.corpName }}</span></div>
                    </template>
                </el-table-column>
                <el-table-column label="接待人">
                    <template #default="{ row }">{{ row.addBy }}</template>
                </el-table-column>
                <el-table-column label="添加人(坐席)">
                    <template #default="{ row }">{{ row.internal_user_name || row.agentName || '-' }}</template>
                </el-table-column>
                <el-table-column label="发起场景">
                    <template #default="{ row }">
                        <span class="t_tag" :class="sceneClass(row.scene)">{{ row.scene || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="接待方式">
                    <template #default="{ row }">
                        <span v-if="row.channel" class="t_tag" :class="channelClass(row.channel)">{{ channelName(row.channel) }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="咨询时间">
                    <template #default="{ row }"><span class="t_cust_id">{{ row.time }}</span></template>
                </el-table-column>
                <el-table-column label="操作" width="130" fixed="right" align="center">
                    <template #default="{ row }">
                        <el-button size="small" class="t_btn_view" @click.stop="checkchat(row)">查看详情</el-button>
                    </template>
                </el-table-column>
                <template #empty>
                    <div class="t_table_empty">未找到符合条件的聊天记录，请调整检索条件。</div>
                </template>
            </el-table>
            <div class="t_pager">
                <el-pagination
                    background
                    :current-page="searchdata.page"
                    :page-size="searchdata.page_size"
                    :total="total"
                    layout="total, prev, pager, next, jumper"
                    @current-change="page_change"
                />
            </div>
        </div>

        <!-- 会话详情弹窗 -->
        <el-dialog
            v-model="isshowdetail"
            width="960px"
            top="5vh"
            class="t_chatlog_dialog"
            destroy-on-close
        >
            <template #header>
                <div class="t_dlg_head">
                    <div class="t_dlg_title">会话详情 · {{ detailItem.reception_id || '-' }}</div>
                    <div class="t_dlg_meta">
                        <span class="t_hm_chip" :class="hmSceneClass(detailItem.scene)">{{ detailItem.scene || '-' }}</span>
                        <span v-if="detailItem.channel" class="t_hm_chip" :class="hmClass(detailItem.channel)">{{ channelName(detailItem.channel) }}</span>
                        <span class="t_hm_sep">·</span>
                        <span>{{ detailItem.time }}</span>
                    </div>
                </div>
            </template>
            <div class="t_detail_split">
                <div class="t_detail_left">
                    <div class="t_chat_thread_title"><span class="t_bar"></span>聊天上下文记录</div>
                    <div class="t_chat_thread">
                        <template v-for="(g, gindex) in groupedChat" :key="gindex">
                            <div class="t_chat_datebar">{{ g.day }}</div>
                            <template v-for="(m, midx) in g.data" :key="midx">
                                <!-- 转接 / 系统提示 -->
                                <div v-if="isTransfer(m)" class="t_b_transfer"><span>{{ getMsgText(m) }}</span></div>
                                <div v-else class="t_b_row" :class="isAgentMsg(m) ? 't_b_right' : 't_b_left'">
                                    <!-- 真人客服 / 客户显示姓名；AI 回复在气泡内展示「AI 智能客服」角标 -->
                                    <div v-if="!isAiMsg(m)" class="t_b_name">
                                        <template v-if="isAgentMsg(m)">
                                            <span class="t_b_meta">
                                                <span v-if="m.receptionist_name" class="t_b_meta_item">
                                                    <span class="t_b_meta_k">接待人</span>{{ m.receptionist_name }}
                                                </span>
                                                <span v-if="m.receptionist_name" class="t_b_meta_divider"></span>
                                                <span class="t_b_meta_item">
                                                    <span class="t_b_meta_k">坐席</span>{{ msgName(m) }}
                                                </span>
                                            </span>
                                        </template>
                                        <template v-else>{{ msgName(m) }}</template>
                                    </div>
                                    <div class="t_b_bubble" :class="bubbleClass(m)">
                                        <span v-if="isAiMsg(m)" class="t_b_role">AI 智能客服</span>
                                        <!-- 图片（客户发看缩略图，客服发看原图） -->
                                        <div v-if="m.msgtype == 'Picture'" class="t_b_media">
                                            <img class="t_b_img" :src="m.sender_type == 2 ? parseMsg(m).thumburl : parseMsg(m).url" alt="">
                                        </div>
                                        <!-- Emoji 图片 -->
                                        <div v-else-if="m.msgtype == 'Emoji'" class="t_b_media t_b_media_tip">
                                            <img class="t_b_emoji_img" :src="parseMsg(m).url" alt="">
                                        </div>
                                        <!-- 文件 -->
                                        <div v-else-if="m.msgtype == 'File'" class="t_b_media t_b_file">
                                            <el-icon :size="18" style="margin-right: 6px; flex-shrink: 0;"><Document /></el-icon>
                                            <div class="t_b_file_info">
                                                <div class="t_b_file_name">{{ parseMsg(m).name || '文件' }}</div>
                                                <div class="t_b_file_size">{{ parseMsg(m).size || '请在手机上查看' }}</div>
                                            </div>
                                        </div>
                                        <!-- 语音 -->
                                        <div v-else-if="m.msgtype == 'Voice'" class="t_b_media t_b_media_tip">
                                            <el-icon :size="16" style="margin-right: 6px;"><Microphone /></el-icon>
                                            <span>语音消息：请在手机上查看</span>
                                            <audio v-if="parseMsg(m).url" :src="parseMsg(m).url" controls style="width: 180px; margin-top: 6px;"></audio>
                                        </div>
                                        <!-- 视频 -->
                                        <div v-else-if="m.msgtype == 'Video'" class="t_b_media t_b_media_tip">
                                            <el-icon :size="16" style="margin-right: 6px;"><VideoCamera /></el-icon>
                                            <span>视频消息：请在手机上查看</span>
                                        </div>
                                        <!-- 链接 -->
                                        <div v-else-if="m.msgtype == 'Link'" class="t_b_media t_b_link">
                                            <img v-if="parseMsg(m).thumburl" class="t_b_link_img" :src="parseMsg(m).thumburl" alt="">
                                            <div class="t_b_link_info">
                                                <div class="t_b_link_title">{{ parseMsg(m).title }}</div>
                                                <div class="t_b_link_desc">{{ parseMsg(m).desc }}</div>
                                            </div>
                                        </div>
                                        <!-- 小程序 -->
                                        <div v-else-if="m.msgtype == 'WeApp'" class="t_b_media t_b_weapp">
                                            <img v-if="parseMsg(m).iconurl" class="t_b_weapp_icon_img" :src="parseMsg(m).iconurl" alt="">
                                            <div class="t_b_weapp_info">
                                                <div class="t_b_weapp_name">{{ parseMsg(m).appname }}</div>
                                                <div class="t_b_weapp_title">{{ parseMsg(m).title || '小程序' }}</div>
                                            </div>
                                        </div>
                                        <!-- 文本 -->
                                        <div v-else class="t_b_text">{{ getMsgText(m) }}</div>
                                        <span class="t_b_time">{{ timeText(m) }}<template v-if="isAiMsg(m)"> · AI 智能客服</template></span>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <div v-if="!chatData.data.length" class="t_chat_empty">暂无聊天记录</div>
                    </div>
                </div>
                <div class="t_detail_right">
                    <!-- 客户信息 -->
                    <div class="t_detail_sec">
                        <div class="t_detail_sec_title"><span class="t_bar"></span>客户信息<span class="t_sec_sub">系统客户 ID · {{ detailItem.external_contact_id || '-' }}</span></div>
                        <div class="t_cust_head">
                            <img class="t_cust_avatar" :src="detailItem.avatar" alt="">
                            <div class="t_cust_head_name">{{ detailItem.contact_name || mineinfo.data.contact_name || '-' }}</div>
                            <div v-if="mineinfo.data.is_blacklist == 1" class="t_black_order">黑名单</div>
                        </div>
                        <div class="t_meta_grid">
                            <div class="t_meta_item">
                                <div class="t_meta_k">姓名</div>
                                <div class="t_meta_v">{{ mineinfo.data.id_card_name || '-' }}</div>
                            </div>
                            <div class="t_meta_item">
                                <div class="t_meta_k">手机号</div>
                                <div class="t_meta_v t_mono">{{ mineinfo.data.remark_mobiles || '-' }}</div>
                            </div>
                            <div class="t_meta_item t_meta_full">
                                <div class="t_meta_k">个人信息</div>
                                <div class="t_meta_v">{{ personalInfoText }}</div>
                            </div>
                            <div class="t_meta_item">
                                <div class="t_meta_k">来源</div>
                                <div class="t_meta_v">{{ mineinfo.data.source || '-' }}</div>
                            </div>
                            <div class="t_meta_item">
                                <div class="t_meta_k">已添加</div>
                                <div class="t_meta_v">{{ mineinfo.data.add_time || '-' }}</div>
                            </div>
                            <div class="t_meta_item t_meta_full">
                                <div class="t_meta_k">备注信息</div>
                                <div class="t_meta_v">{{ mineinfo.data.remark || '-' }}</div>
                            </div>
                        </div>
                        <!-- 标签 -->
                        <div class="t_tag_row">
                            <span class="t_tag_row_label">标签</span>
                            <div class="t_tag_list">
                                <span v-for="(t, ti) in tagList" :key="ti" class="t_tag_chip">{{ t }}</span>
                                <span v-if="!tagList.length" class="t_tag_empty">暂无标签</span>
                            </div>
                        </div>
                    </div>
                    <!-- 订单信息：区分号卡（persontype=1）与体育（persontype=2） -->
                    <div class="t_detail_sec">
                        <div class="t_detail_sec_title"><span class="t_bar"></span>订单信息</div>
                        <!-- 号卡类别 -->
                        <template v-if="persontype == 1">
                            <div class="t_order_list" v-if="orderinfolist.data.length">
                                <div class="t_order_item" v-for="(o, oi) in orderinfolist.data" :key="oi">
                                    <div class="t_order_top">
                                        <span class="t_order_no">订单号：{{ o.id }}</span>
                                        <span class="t_order_status" :class="orderStatusClass(o.orderStatus)">{{ o.orderStatus }}</span>
                                    </div>
                                    <div class="t_order_row"><span class="t_order_label">商品名称</span><span class="t_order_row_val">{{ o.order_page_title }}</span></div>
                                    <div class="t_order_row"><span class="t_order_label">商品编码</span><span class="t_order_row_val t_mono">{{ o.fetch_code }}</span></div>
                                    <div class="t_order_row"><span class="t_order_label">订单来源</span><span class="t_order_row_val">{{ o.source }}</span></div>
                                    <div class="t_order_row"><span class="t_order_label">收货地址</span><span class="t_order_row_val">{{ o.address_province }} {{ o.address_city }} {{ o.address_district }}</span></div>
                                    <div class="t_order_row"><span class="t_order_label">订单状态</span><span class="t_order_row_val">{{ o.orderStatus }}</span></div>
                                    <div class="t_order_bottom">
                                        <div class="t_order_row"><span class="t_order_label">物流信息</span><span class="t_order_row_val">{{ o.tracking_number }}</span></div>
                                        <span class="t_order_price">¥{{ o.price }}</span>
                                    </div>
                                    <div class="t_order_sub">下单时间：{{ o.created_at }}</div>
                                </div>
                            </div>
                            <div class="t_order_empty" v-else>该客户暂无关联订单</div>
                        </template>
                        <!-- 体育类别 -->
                        <template v-else-if="persontype == 2">
                            <div v-if="sportorderinfolist.data.url" class="t_sport_frame">
                                <iframe :src="sportorderinfolist.data.url" class="t_web"></iframe>
                            </div>
                            <div v-else class="t_order_empty">暂无订单信息</div>
                        </template>
                    </div>
                </div>
            </div>
            <template #footer>
                <el-button class="t_btn_ghost" @click="isshowdetail = false">关闭</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script setup>

import { ref, reactive, computed, onMounted, watch } from 'vue'
import { newgetcomp2, newgetczlist, newgetzxlist, newgetchatmsglist, newsessionlist, newsessionstatistics, newgetplatphoneadmin, newgetorderinfo, newgetsportorder,newgetpeo } from '@/assets/js/common.js'


onMounted(() => {
    console.log('onMounted')
    getlist()
    getallpeolist()
    getallpeolist2()
    //获取企微主体下拉
    getcorplist()
})

/* ==================== 下拉数据 ==================== */
//企微主体下拉
const corpList = reactive({ data: [] })
const getcorplist = () => {
    newgetcomp2().then((response) => {
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}

//操作员（添加人）下拉
const allpeolist2 = reactive({ data: [] })
let operatorRequestId = 0
const getallpeolist2 = () => {
    const requestId = ++operatorRequestId
    newgetczlist({ page: 1, page_size: 2000, username: '', corp_id: searchdata.corp_ids.join(',') }).then((response) => {
        //仅更新最新请求，避免快速切换主体时旧响应覆盖新列表
        if (requestId == operatorRequestId && response.data.msg.code == 0) {
            allpeolist2.data = response.data.data.data
        }
    })
}

//接待坐席下拉
const allpeolist = reactive({ data: [] })
let seatRequestId = 0
const getallpeolist = () => {
    const requestId = ++seatRequestId
    newgetpeo({ include_disabled: 1, corp_id: searchdata.corp_ids.join(',') }).then((response) => {
        //仅更新最新主体范围的坐席列表，避免旧响应覆盖新结果
        if (requestId == seatRequestId && response.data.msg.code == 0) {
            allpeolist.data = response.data.data
        }
    })
}

//发起场景 / 接待方式 选项
const sceneoptions = reactive({ data: ['客户发起', '客服发起'] })
const channeloptions = reactive({ data: ['人工', 'AI', 'AI转人工'] })

/* ==================== 搜索 ==================== */
const searchdata = reactive({
    page: 1,
    page_size: 20,
    sid: '',
    name: '',
    phone: '',
    keywords: '',
    corp_ids: [],
    employee_ids: [],
    internal_user_ids: [],
    start_time: '',
    end_time: '',
    scene: '',
    channel: ''
})

watch(() => searchdata.corp_ids, () => {
    searchdata.employee_ids = []
    allpeolist2.data = []
    getallpeolist2()
    searchdata.internal_user_ids = []
    allpeolist.data = []
    getallpeolist()
}, { deep: true })

//时间段
const timeaer = ref('')
const changedate = (val) => {
    console.log(val)
    if (val) {
        searchdata.start_time = val[0]
        searchdata.end_time = val[1]
    } else {
        searchdata.start_time = ''
        searchdata.end_time = ''
    }
}

const handleEdit = (e) => {
    let value = e.replace(/[^\d]/g, "") // 只能输入数字
    value = value.replace(/^0+(\d)/, "$1") // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
    value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
    searchdata.phone = value
}

//搜索
const searchbtn = () => {
    tableData.data = []
    searchdata.page = 1
    getlist()
}

//重置
const resetsearch = () => {
    searchdata.page = 1
    searchdata.sid = ''
    searchdata.name = ''
    searchdata.phone = ''
    searchdata.keywords = ''
    searchdata.corp_ids = []
    searchdata.employee_ids = []
    searchdata.internal_user_ids = []
    searchdata.start_time = ''
    searchdata.end_time = ''
    searchdata.scene = ''
    searchdata.channel = ''
    timeaer.value = ''
    getlist()
}

/* ==================== 列表 ==================== */
const tableData = reactive({ data: [] })
const total = ref(0)

//分页
const page_change = (val) => {
    searchdata.page = val
    getlist(false)
}

//列表与统计使用同一份筛选快照，数组不再引用正在编辑的表单值。
const buildHistoryFilters = () => ({
    reception_id: searchdata.sid,
    corp_ids: [...searchdata.corp_ids],
    employee_ids: [...searchdata.employee_ids],
    internal_user_ids: [...searchdata.internal_user_ids],
    contact: searchdata.name,
    phone: searchdata.phone,
    start_time: searchdata.start_time,
    end_time: searchdata.end_time,
    scene: sceneCode[searchdata.scene] !== undefined ? sceneCode[searchdata.scene] : null,
    reception_method: receptionCode[searchdata.channel] !== undefined ? receptionCode[searchdata.channel] : null
})

let listRequestId = 0
//获取会话列表（calcStat：是否同步刷新上方统计卡片）
const getlist = (calcStat = true) => {
    const filters = buildHistoryFilters()
    const requestId = ++listRequestId
    if (calcStat) getStatistics(filters)
    newsessionlist({
        ...filters,
        page: searchdata.page,
        page_size: searchdata.page_size,
        content: searchdata.keywords
    }).then((response) => {
        if (requestId != listRequestId || response?.data?.msg?.code != 0) return
        console.log('---客户会话列表')
        console.log(response.data.data)
        const rows = (response.data.data.data || []).map((item) => enrichItem(item))
        total.value = response.data.data.total || rows.length
        tableData.data = applyLocalFilter(rows, filters.internal_user_ids)
    })
}

//本地校验使用本次请求的坐席快照，避免等待响应期间修改筛选影响结果。
const applyLocalFilter = (rows, internalUserIds) => {
    let list = rows
    if (internalUserIds.length) {
        const ids = internalUserIds.map(String)
        list = list.filter((r) => ids.includes(String(r.internal_user_id)))
    }
    return list
}

/* ==================== 会话详情 ==================== */
const isshowdetail = ref(false)
const detailItem = ref({})
const chatData = reactive({ data: [] })

//消息列表接口返回按天分组的结构：[{ send_time: 日期, data: [消息...] }]
//这里统一展开成扁平消息数组，供 groupedChat 再次按天分组渲染
const flattenMsgs = (data) => {
    if (!Array.isArray(data)) return []
    // 若元素本身已带消息字段（sender_type/msgtype/content），说明已是扁平消息数组
    if (data.length && (data[0].sender_type !== undefined || data[0].msgtype !== undefined)) return data
    const flat = []
    data.forEach((g) => {
        if (g && Array.isArray(g.data)) {
            const day = String(g.send_time || '').slice(0, 10)
            g.data.forEach((m) => {
                // 消息时间仅有时分秒时，补上所属日期，便于按天分组展示
                if (m && day && m.send_time != null && String(m.send_time).length <= 8) {
                    m = { ...m, send_time: day + ' ' + m.send_time }
                }
                flat.push(m)
            })
        }
    })
    return flat
}

//点击查看
const checkchat = (item) => {
    console.log(item)
    detailItem.value = item
    // 从列表项获取类别：1=号卡，2=体育
    persontype.value = item.business_identifier
    //清空上次打开的客户信息与订单，避免残留
    mineinfo.data = {}
    orderinfolist.data = []
    sportorderinfolist.data = {}
    //获取右侧客户基础信息（成功后按类别拉取订单）
    getcustominfo()
    newgetchatmsglist({
        page: 1,
        page_size: 2000,
        internal_user_id: item.internal_user_id,
        session_id: item.session_id,
        external_contact_id: item.external_contact_id,
        start_time: searchdata.start_time,
        end_time: searchdata.end_time,
        keywords: searchdata.keywords,
        corp_ids: searchdata.corp_ids.toString()
    }).then((response) => {
        if (response.data.msg.code == 0) {
            console.log('---消息记录')
            console.log(response.data.data)
            chatData.data = flattenMsgs(response.data.data)
        } else {
            chatData.data = []
        }
        isshowdetail.value = true
    })
}

/* ==================== 统计数据 ==================== */
const kpi = reactive({ total: null, ai: null, human: null, ait: null, aiPct: null, humanPct: null })
//筛选值 → 接口枚举值映射（发起场景：1 客服发起 2 客户发起；接待方式：0 人工 1 AI 2 AI转人工）
const sceneCode = { '客服发起': 1, '客户发起': 2 }
const receptionCode = { '人工': 0, 'AI': 1, 'AI转人工': 2 }

let statisticsRequestId = 0
//统计接口按完整筛选范围计数，不受列表分页限制。
const getStatistics = (filters) => {
    const requestId = ++statisticsRequestId
    Object.keys(kpi).forEach((key) => { kpi[key] = null })
    newsessionstatistics({ ...filters, page: 1, page_size: 20 }).then((response) => {
        if (requestId != statisticsRequestId || response?.data?.msg?.code != 0) return
        const data = response.data.data
        //无有效统计结果时保持占位，不能把接口异常显示为零。
        if (!data || ![data.session_count, data.ai_count, data.human_count, data.ai_to_human_count]
            .every((value) => Number.isInteger(value) && value >= 0)) return
        kpi.total = data.session_count
        kpi.ai = data.ai_count
        kpi.human = data.human_count
        kpi.ait = data.ai_to_human_count
        kpi.aiPct = kpi.total ? Math.round((kpi.ai / kpi.total) * 100) : 0
        kpi.humanPct = kpi.total ? Math.round((kpi.human / kpi.total) * 100) : 0
    }).catch(() => {
        //全局拦截器负责错误提示，失败时保持占位且不影响列表请求。
        if (requestId == statisticsRequestId) console.warn('历史会话统计请求失败')
    })
}

/* ==================== 列表字段归一化（对接 list/new 接口真实字段） ==================== */
const normalizeChannel = (ch) => String(ch || '').replace(/\s/g, '')
const enrichItem = (item) => {
    return {
        ...item,
        session_id: item.session_id,
        contact_name: item.contact_name || '-',
        external_contact_id: item.external_contact_id || item.contact_id || '-',
        addBy: item.employee_name || '-',
        internal_user_name: item.user_name || '-',
        corpName: item.corp_name || '-',
        corpColor: item.corp_color || '#94A3B8',
        scene: item.scene || '',
        channel: normalizeChannel(item.reception_method),
        time: item.entered_at || ''
    }
}

const sceneClass = (s) => s === '客户发起' ? 't_tag_cust' : 't_tag_agent'
const channelClass = (ch) => ({ 'AI': 't_tag_ai', 'AI转人工': 't_tag_ait', '人工': 't_tag_human' })[ch] || 't_tag_human'
const channelName = (ch) => ({ 'AI': 'AI', 'AI转人工': 'AI 转人工', '人工': '人工' })[ch] || '人工'
const hmClass = (ch) => ch === 'AI' ? 't_hm_ai' : (ch === 'AI转人工' ? 't_hm_ait' : 't_hm_human')
const hmSceneClass = (s) => s === '客户发起' ? 't_hm_cust' : 't_hm_agent'

/* ==================== 消息渲染（按 msgtype 区分，参考 chatpage.vue 的数据结构） ==================== */
const isAgentMsg = (m) => m.sender_type == 1
//AI 回复：客服侧（sender_type=1）且 is_ai_send_msg=1，用独立淡紫气泡 + 「AI 智能客服」角标，不显示姓名
const isAiMsg = (m) => m.sender_type == 1 && m.is_ai_send_msg == 1
//气泡样式：AI 回复 / 真人客服 / 客户 三种
const bubbleClass = (m) => isAiMsg(m) ? 't_bub_ai' : (isAgentMsg(m) ? 't_bub_agent' : 't_bub_cust')

const msgName = (m) => {
    if (m.sender_type == 1) return m.internal_user_name || (detailItem.value && detailItem.value.internal_user_name) || '客服'
    return m.external_contact_name || (detailItem.value && detailItem.value.contact_name) || '客户'
}
//消息展示时间：完整日期时间 → HH:mm
const timeText = (m) => {
    const s = String(m.send_time || m.created_at || '')
    const r = s.match(/(\d{1,2}):(\d{2})/)
    return r ? (r[1] + ':' + r[2]) : s
}
//非文本消息 content 为 JSON 字符串（或对象），解析成对象后按各自字段读取（Picture/File/Voice/Video/Link/WeApp/Emoji/QuoteMsg）
const parseMsg = (m) => {
    try {
        if (typeof m.content === 'object') return m.content
        return JSON.parse(m.content || '{}')
    } catch (e) {
        return {}
    }
}
//文本消息 content 为明文；若为 JSON 字符串（如 QuoteMsg 的 {text}），提取 text，避免渲染出 [object Object]
const getMsgText = (m) => {
    const c = m.content
    if (c == null) return ''
    if (typeof c === 'object') return c.text || c.content || ''
    if (typeof c === 'string') {
        try {
            const o = JSON.parse(c)
            if (o && typeof o === 'object') return o.text || o.content || c
        } catch (e) {}
        return c
    }
    return String(c)
}
//转接 / 系统提示
const isTransfer = (m) => {
    const t = String(m.msgtype || '').toLowerCase()
    if (['transfer', 'system', 'sys', 'notice'].includes(t)) return true
    return /转接至|转人工|转交/.test(getMsgText(m))
}
//按日期分组，展示「日期条 + 当天消息」
const groupedChat = computed(() => {
    const groups = []
    let cur = null
    chatData.data.forEach((m) => {
        const day = String(m.send_time || '').slice(0, 10)
        if (!cur || cur.day !== day) {
            cur = { day, data: [m] }
            groups.push(cur)
        } else {
            cur.data.push(m)
        }
    })
    return groups
})

/* ==================== 客户信息 & 订单信息（对接接口） ==================== */
// 客户类型：1=号卡，2=体育（由列表项 business_identifier 决定）
const persontype = ref(null)

// 客户基础信息（对接 newgetplatphoneadmin）
const mineinfo = reactive({
    data: {}
})

// 获取客户基础信息
const getcustominfo = () => {
    newgetplatphoneadmin({
        external_contact_id: detailItem.value.external_contact_id,
        internal_user_id: detailItem.value.internal_user_id
    }).then((response) => {
        if (response.data.msg.code == 0) {
            mineinfo.data = response.data.data || {}
            // 类别：1=号卡，2=体育
            if (persontype.value == 1) {
                getorderinfo()
            } else if (persontype.value == 2) {
                getsportorderinfo()
            }
        } else {
            mineinfo.data = {}
        }
    })
}

// 标签列表（静态：tag_titles 逗号分隔，后续对接 newgettaglist）
const tagList = computed(() => {
    const s = mineinfo.data.tag_titles || ''
    return s.split(',').map((x) => x.trim()).filter(Boolean)
})

// 根据身份证号获取性别
const getGenderByIdCard = (idCard) => {
    if (!idCard || typeof idCard !== 'string' || idCard.length !== 18) return ''
    const d = idCard.charAt(16)
    if (isNaN(parseInt(d))) return ''
    return parseInt(d) % 2 === 1 ? '男' : '女'
}
const genderText = computed(() => getGenderByIdCard(mineinfo.data.id_card_num))

// 根据身份证号获取年龄
const getAgeByIdCard = (idCard) => {
    if (!idCard || typeof idCard !== 'string' || idCard.length !== 18) return ''
    const year = parseInt(idCard.substring(6, 10))
    const month = parseInt(idCard.substring(10, 12))
    const day = parseInt(idCard.substring(12, 14))
    if (isNaN(year) || isNaN(month) || isNaN(day)) return ''
    const now = new Date()
    let age = now.getFullYear() - year
    if (now.getMonth() + 1 < month || (now.getMonth() + 1 === month && now.getDate() < day)) {
        age--
    }
    return age
}
const ageText = computed(() => getAgeByIdCard(mineinfo.data.id_card_num))

// 省市区：号卡订单取第一条订单的省市区；体育订单或无号卡订单不显示
const addressText = computed(() => {
    if (persontype.value !== 1 || !orderinfolist.data.length) return ''
    const o = orderinfolist.data[0]
    return [o.address_province, o.address_city, o.address_district].filter(Boolean).join(' ')
})

// 个人信息：年龄 · 性别 · 省市区
const personalInfoText = computed(() => {
    const parts = []
    if (ageText.value !== '') parts.push(ageText.value + '岁')
    if (genderText.value) parts.push(genderText.value)
    if (addressText.value) parts.push(addressText.value)
    return parts.join(' · ') || '-'
})

// 号卡订单（对接 newgetorderinfo）
const orderinfolist = reactive({
    data: []
})

// 获取号卡订单信息
const getorderinfo = () => {
    newgetorderinfo({
        mobiles: mineinfo.data.remark_mobiles,
        external_contact_id: detailItem.value.external_contact_id
    }).then((response) => {
        if (response.data.msg.code == 0) {
            orderinfolist.data = response.data.data || []
        } else {
            orderinfolist.data = []
        }
    })
}

// 体育赛事订单（对接 newgetsportorder；有 url 时用 iframe 展示）
const sportorderinfolist = reactive({
    data: {}
})

// 获取体育订单信息
const getsportorderinfo = () => {
    sportorderinfolist.data = {}
    newgetsportorder({
        external_contact_id: detailItem.value.external_contact_id
    }).then((response) => {
        if (response.data.msg.code == 0) {
            sportorderinfolist.data = response.data.data || {}
        } else {
            sportorderinfolist.data = {}
        }
    })
}

// 订单状态标签样式（与参考文件状态色一致）
const orderStatusClass = (st) => {
    const map = { '已支付': 't_paid', '已发货': 't_ship', '已退费': 't_refund', '已退款': 't_refund', '已激活': 't_active', '已生成': 't_active', '待发货': 't_wait', '申诉中': 't_wait' }
    return map[st] || 't_wait'
}
</script>
<style scoped>
/* 覆盖外层白色卡片，露出页面浅灰背景，保持与参考设计一致 */
.t_content_view {
    background: transparent;
    box-shadow: none;
    padding: 0;
    padding-bottom: 40px;
}

/* ---------- 页面标题 ---------- */
.t_page_title {
    font-size: 20px;
    font-weight: 800;
    margin: 4px 0 18px;
    color: #1E293B;
}
.t_page_title small {
    font-weight: 500;
    color: #64748B;
    font-size: 13px;
    margin-left: 10px;
}

/* ---------- 面板 ---------- */
.t_panel,
.t_table_panel {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    padding: 18px 20px;
    margin-bottom: 18px;
}
.t_table_panel {
    padding: 0;
    overflow: hidden;
}
.t_panel_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    gap: 10px;
    flex-wrap: wrap;
}
.t_panel_title {
    font-size: 15px;
    font-weight: 700;
    color: #1E293B;
}

/* ---------- 检索字段 ---------- */
.t_fld {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;
}
.t_fld label {
    font-size: 12.5px;
    font-weight: 600;
    color: #64748B;
}
.t_fld .el-input,
.t_fld .el-select,
.t_fld .el-date-editor {
    width: 100%;
}
:deep(.t_fld .el-input__wrapper),
:deep(.t_fld .el-select__wrapper),
:deep(.t_fld .el-date-editor .el-input__wrapper) {
    background: #fff;
    box-shadow: 0 0 0 1px #E8ECF3 inset;
    border-radius: 10px;
}
:deep(.t_fld .el-input__wrapper.is-focus),
:deep(.t_fld .el-select__wrapper.is-focused),
:deep(.t_fld .el-date-editor.is-focus .el-input__wrapper) {
    box-shadow: 0 0 0 1px #4F46E5 inset;
}
:deep(.t_fld .el-input__inner) {
    font-size: 13.5px;
    color: #1E293B;
}

.t_filter_actions {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 14px;
    margin-top: 2px;
    border-top: 1px dashed #E8ECF3;
}

/* ---------- 按钮 ---------- */
.t_btn_primary.el-button {
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    border: 0;
    border-radius: 10px;
    padding: 9px 20px;
    font-weight: 700;
    font-size: 13px;
    color: #fff;
}
.t_btn_primary.el-button:hover {
    opacity: .92;
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    color: #fff;
}
.t_btn_ghost.el-button {
    background: #F1F3F9;
    border: 0;
    border-radius: 10px;
    padding: 9px 20px;
    font-weight: 600;
    font-size: 13px;
    color: #1E293B;
}
.t_btn_ghost.el-button:hover {
    background: #E7EAF2;
    color: #1E293B;
}
.t_btn_view.el-button {
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    border: 0;
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 12.5px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
}
.t_btn_view.el-button:hover {
    opacity: .92;
    color: #fff;
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
}

/* ---------- 统计卡片 ---------- */
.t_stat_row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 18px;
}
.t_stat_card {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    padding: 16px 18px;
}
.t_stat_label {
    font-size: 12.5px;
    color: #64748B;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
}
.t_dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.t_stat_value {
    font-size: 28px;
    font-weight: 800;
    color: #1E293B;
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    gap: 6px;
}
.t_stat_value .t_v_aux {
    font-size: 11px;
    font-weight: 400;
    color: #B8C2D0;
}
.t_stat_sub {
    font-size: 12px;
    color: #64748B;
    margin-top: 4px;
}
.t_stat_sub b {
    color: #1E293B;
}

/* ---------- 表格 ---------- */
:deep(.el-table) {
    --el-table-border-color: #EEF1F6;
    --el-table-header-bg-color: #FBFCFE;
    --el-table-row-hover-bg-color: #F8FAFF;
    font-size: 13.5px;
    color: #1E293B;
}
:deep(.el-table th.el-table__cell) {
    padding: 14px 16px;
    background: #FBFCFE;
    border-bottom: 1px solid #E8ECF3;
    white-space: nowrap;
}
:deep(.el-table td.el-table__cell) {
    padding: 14px 16px;
    border-bottom: 1px solid #EEF1F6;
}
:deep(.el-table__inner-wrapper::before) {
    display: none;
}

.t_id_cell {
    font-family: "SF Mono", ui-monospace, Menlo, Consolas, monospace;
    font-weight: 700;
    font-size: 12.5px;
    color: #1E293B;
}
.t_cust_cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.t_cust_name {
    font-weight: 700;
    color: #1E293B;
}
.t_cust_id {
    font-size: 12px;
    color: #64748B;
    font-family: "SF Mono", ui-monospace, Menlo, Consolas, monospace;
}
.t_corp_cell {
    display: flex;
    align-items: center;
    gap: 7px;
}
.t_corp_name {
    word-break: break-all;
    line-height: 1.4;
}
.t_corp_dot {
    width: 8px;
    height: 8px;
    border-radius: 3px;
    flex-shrink: 0;
}
.t_table_empty {
    text-align: center;
    color: #64748B;
    padding: 38px 0;
    font-size: 13.5px;
}

/* ---------- 徽章（胶囊） ---------- */
.t_tag {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    padding: 3px 11px;
    border-radius: 999px;
    white-space: nowrap;
}
.t_tag_cust {
    color: #4F46E5;
    background: rgba(79, 70, 229, .10);
}
.t_tag_agent {
    color: #10B981;
    background: rgba(16, 185, 129, .12);
}
.t_tag_human {
    color: #B45309;
    background: rgba(245, 158, 11, .16);
}
.t_tag_ai {
    color: #7C3AED;
    background: rgba(124, 58, 237, .12);
}
.t_tag_ait {
    color: #9333EA;
    background: rgba(147, 51, 234, .12);
    border: 1px solid rgba(245, 158, 11, .45);
}

/* ---------- 分页 ---------- */
.t_pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 13px 16px;
    border-top: 1px solid #EEF1F6;
}
:deep(.t_pager .el-pagination) {
    --el-pagination-active-bg-color: #4F46E5;
    --el-pagination-active-color: #fff;
    font-size: 13px;
}

/* ---------- 详情弹窗内容区（.t_dlg_head / .t_dlg_meta 等位于 scoped 内，样式见下方） ---------- */
.t_dlg_head {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
}
.t_dlg_title {
    font-size: 16px;
    font-weight: 800;
    color: #1E293B;
}
.t_dlg_meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-size: 12px;
    color: #64748B;
    font-weight: 600;
}
.t_hm_chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 999px;
    background: #F1F3F9;
    color: #1E293B;
    font-weight: 600;
}
.t_hm_chip.t_hm_ai {
    color: #7C3AED;
    background: rgba(124, 58, 237, .10);
}
.t_hm_chip.t_hm_human {
    color: #B45309;
    background: rgba(245, 158, 11, .16);
}
.t_hm_chip.t_hm_ait {
    color: #9333EA;
    background: rgba(147, 51, 234, .10);
    border: 1px solid rgba(245, 158, 11, .4);
}
.t_hm_chip.t_hm_cust {
    color: #4F46E5;
    background: rgba(79, 70, 229, .10);
}
.t_hm_chip.t_hm_agent {
    color: #10B981;
    background: rgba(16, 185, 129, .12);
}
.t_hm_sep {
    color: #CBD5E1;
}

.t_detail_split {
    height: 62vh;
    display: flex;
    overflow: hidden;
}
.t_detail_left {
    flex: 1.6;
    min-width: 0;
    overflow-y: auto;
    padding: 18px 20px;
}
.t_detail_right {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    padding: 18px 20px 20px;
    background: #FBFCFE;
    border-left: 1px solid #E8ECF3;
}
.t_detail_left::-webkit-scrollbar,
.t_detail_right::-webkit-scrollbar {
    width: 8px;
}
.t_detail_left::-webkit-scrollbar-thumb,
.t_detail_right::-webkit-scrollbar-thumb {
    background: #CBD5E1;
    border-radius: 4px;
}
.t_detail_left::-webkit-scrollbar-track,
.t_detail_right::-webkit-scrollbar-track {
    background: transparent;
}

/* ---------- 聊天上下文 ---------- */
.t_chat_thread_title,
.t_detail_sec_title {
    font-size: 13px;
    font-weight: 800;
    color: #1E293B;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.t_bar {
    width: 4px;
    height: 15px;
    border-radius: 3px;
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
}
.t_chat_datebar {
    text-align: center;
    margin: 12px 0;
    font-size: 11.5px;
    font-weight: 600;
    color: #64748B;
}
.t_chat_thread {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.t_chat_empty {
    text-align: center;
    color: #64748B;
    padding: 40px 0;
    font-size: 13px;
}

/* 气泡行 */
.t_b_row {
    display: flex;
    flex-direction: column;
    max-width: 86%;
}
.t_b_left {
    align-self: flex-start;
    align-items: flex-start;
}
.t_b_right {
    align-self: flex-end;
    align-items: flex-end;
}
.t_b_name {
    font-size: 11.5px;
    font-weight: 700;
    color: #64748B;
    margin-bottom: 5px;
    padding: 0 3px;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    max-width: 100%;
}
/* 客服消息头部：接待人与坐席合并为一个胶囊，沿用坐席的琥珀配色 */
.t_b_meta {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    padding: 3px 11px;
    border-radius: 999px;
    background: rgba(245, 158, 11, .14);
    color: #B45309;
    font-size: 11.5px;
    font-weight: 700;
    line-height: 1.35;
    white-space: nowrap;
}
.t_b_meta_k {
    font-size: 10.5px;
    font-weight: 500;
    color: #64748B;
    margin-right: 5px;
}
.t_b_meta_divider {
    width: 1px;
    height: 10px;
    background: rgba(180, 83, 9, .22);
}
.t_b_bubble {
    max-width: 100%;
    padding: 10px 13px;
    font-size: 13.5px;
    line-height: 1.6;
    position: relative;
    color: #1E293B;
}
.t_b_time {
    display: block;
    font-size: 11px;
    margin-top: 5px;
    opacity: .7;
}
.t_bub_cust {
    background: #EEF1F6;
    border-radius: 14px 14px 14px 4px;
}
.t_bub_agent {
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    color: #fff;
    border-radius: 14px 14px 4px 14px;
}
.t_bub_agent .t_b_time {
    color: #fff;
}
/* AI 回复气泡（淡紫，独立于真人客服渐变气泡） */
.t_bub_ai {
    background: rgba(124, 58, 237, .10);
    color: #5B21B6;
    border: 1px solid rgba(124, 58, 237, .22);
    border-radius: 14px 14px 4px 14px;
}
.t_bub_ai .t_b_time {
    color: #5B21B6;
    opacity: .75;
}
.t_b_role {
    display: inline-block;
    font-size: 10.5px;
    font-weight: 700;
    color: #fff;
    background: #7C3AED;
    border-radius: 6px;
    padding: 1px 6px;
    margin-bottom: 4px;
}

/* 转接提示 */
.t_b_transfer {
    text-align: center;
    margin: 12px 0;
}
.t_b_transfer span {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    color: #9333EA;
    background: rgba(147, 51, 234, .08);
    border: 1px dashed rgba(245, 158, 11, .55);
    border-radius: 20px;
    padding: 4px 14px;
}

/* 非文本消息卡片 */
.t_b_media {
    background: #fff;
    border: 1px solid #E8ECF3;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 5px;
}
.t_bub_agent .t_b_media {
    border-color: rgba(255, 255, 255, .35);
}
.t_b_img {
    width: 200px;
    max-width: 100%;
    display: block;
    cursor: zoom-in;
}
.t_b_file {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    color: #1E293B;
}
.t_b_file:hover {
    border-color: #4F46E5;
}
.t_b_file_info {
    min-width: 0;
}
.t_b_file_name {
    font-size: 13px;
    font-weight: 700;
    color: #4F46E5;
    word-break: break-all;
}
.t_b_file_size {
    font-size: 11px;
    color: #64748B;
    margin-top: 2px;
}
.t_b_weapp {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    color: #1E293B;
}
.t_b_weapp_icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #4F46E5, #7C3AED);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    display: grid;
    place-items: center;
    flex-shrink: 0;
}
.t_b_weapp_info {
    min-width: 0;
}
.t_b_weapp_name {
    font-size: 13px;
    font-weight: 700;
}
.t_b_weapp_title {
    font-size: 11.5px;
    color: #64748B;
    margin-top: 3px;
    word-break: break-all;
}
.t_b_media_tip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    font-size: 12.5px;
    color: #64748B;
}
.t_b_link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
    color: #1E293B;
}
.t_b_link:hover {
    border-color: #4F46E5;
}
.t_b_link_img {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    object-fit: cover;
    flex-shrink: 0;
}
.t_b_link_info {
    min-width: 0;
}
.t_b_link_title {
    font-size: 13px;
    font-weight: 700;
    color: #4F46E5;
    word-break: break-all;
}
.t_b_link_desc {
    font-size: 11.5px;
    color: #64748B;
    margin-top: 3px;
    word-break: break-all;
}
.t_b_link_url {
    font-size: 11.5px;
    color: #64748B;
    margin-top: 3px;
    word-break: break-all;
}
.t_b_emoji_img {
    width: auto;
    max-width: 60px;
    max-height: 60px;
    display: block;
}
.t_b_weapp_icon_img {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    object-fit: cover;
    flex-shrink: 0;
}
.t_b_text {
    white-space: pre-wrap;
    word-break: break-word;
}

/* ---------- 右侧信息 ---------- */
.t_detail_sec {
    margin-bottom: 18px;
}
.t_detail_sec:last-child {
    margin-bottom: 0;
}
.t_detail_sec_title .t_sec_sub {
    font-size: 11.5px;
    font-weight: 600;
    color: #64748B;
    margin-left: auto;
}
.t_cust_head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}
.t_cust_avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}
.t_cust_head_name {
    font-size: 14px;
    font-weight: 700;
    color: #1E293B;
}
.t_black_order {
    font-size: 12px;
    color: #fff;
    background: #141414;
    padding: 3px 10px;
    border-radius: 5px;
    margin-left: auto;
}
.t_meta_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 16px;
    background: #EEF1F6;
    border-radius: 12px;
    padding: 14px 16px;
}
.t_meta_k {
    font-size: 11.5px;
    color: #64748B;
    font-weight: 600;
    margin-bottom: 3px;
}
.t_meta_v {
    font-size: 13.5px;
    font-weight: 600;
    word-break: break-all;
    color: #1E293B;
}
.t_meta_v.t_mono {
    font-family: "SF Mono", ui-monospace, Menlo, Consolas, monospace;
}
.t_meta_full {
    grid-column: 1 / -1;
}
.t_tag_row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 12px;
    padding: 0 2px;
}
.t_tag_row_label {
    flex-shrink: 0;
    font-size: 11.5px;
    color: #64748B;
    font-weight: 600;
    line-height: 22px;
}
.t_tag_list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.t_tag_chip {
    font-size: 12px;
    font-weight: 600;
    color: #4F46E5;
    background: rgba(79, 70, 229, .10);
    border-radius: 999px;
    padding: 3px 11px;
    white-space: nowrap;
}
.t_tag_empty {
    font-size: 12.5px;
    color: #64748B;
}

/* ---------- 订单信息 ---------- */
.t_order_list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.t_order_item {
    background: #fff;
    border: 1px solid #E8ECF3;
    border-radius: 10px;
    padding: 11px 13px;
}
.t_order_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}
.t_order_no {
    font-family: "SF Mono", ui-monospace, Menlo, Consolas, monospace;
    font-size: 12.5px;
    font-weight: 700;
    color: #1E293B;
}
.t_order_status {
    font-size: 11.5px;
    font-weight: 700;
    padding: 2px 9px;
    border-radius: 999px;
    white-space: nowrap;
}
.t_order_status.t_paid {
    color: #10B981;
    background: rgba(16, 185, 129, .12);
}
.t_order_status.t_ship {
    color: #4F46E5;
    background: rgba(79, 70, 229, .10);
}
.t_order_status.t_refund {
    color: #EF4444;
    background: rgba(239, 68, 68, .10);
}
.t_order_status.t_active {
    color: #7C3AED;
    background: rgba(124, 58, 237, .10);
}
.t_order_status.t_wait {
    color: #F59E0B;
    background: rgba(245, 158, 11, .16);
}
.t_order_row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12.5px;
    color: #1E293B;
    margin-top: 8px;
}
.t_order_label {
    flex-shrink: 0;
    color: #64748B;
    font-size: 12px;
}
.t_order_row_val {
    word-break: break-all;
    font-weight: 600;
}
.t_order_row_val.t_mono {
    font-family: "SF Mono", ui-monospace, Menlo, Consolas, monospace;
}
.t_order_bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    border-top: 1px dashed #EEF1F6;
    margin-top: 8px;
    padding-top: 8px;
}
.t_order_bottom .t_order_row {
    margin-top: 0;
}
.t_order_price {
    font-size: 20px;
    color: #FF6241;
    font-weight: 800;
    flex-shrink: 0;
}
.t_sport_frame {
    background: #fff;
    border: 1px solid #E8ECF3;
    border-radius: 10px;
    overflow: hidden;
}
.t_web {
    width: 100%;
    height: 320px;
    border: none;
    display: block;
}
.t_order_sub {
    font-size: 11.5px;
    color: #64748B;
    margin-top: 4px;
}
.t_order_empty {
    font-size: 12.5px;
    color: #64748B;
    padding: 6px 2px;
}

@media (max-width: 1180px) {
    .t_stat_row {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>

<style>
/* ============== 会话详情弹窗（对齐参考文件 modal 样式；el-dialog 挂载到 body，需全局样式） ============== */
.t_chatlog_dialog {
    --el-dialog-border-radius: 16px;
    border-radius: 16px;
    overflow: hidden;
}
.t_chatlog_dialog .el-dialog__header {
    margin: 0;
    padding: 16px 22px;
    border-bottom: 1px solid #E8ECF3;
}
.t_chatlog_dialog .el-dialog__body {
    padding: 0;
}
.t_chatlog_dialog .el-dialog__footer {
    padding: 13px 22px;
    border-top: 1px solid #E8ECF3;
    text-align: right;
}
</style>
